// DS: i2.3
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const GalleryGrid = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 1v6a1 1 0 001 1h6a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1zm10 0v6a1 1 0 001 1h6a1 1 0 001-1V1a1 1 0 00-1-1h-6a1 1 0 00-1 1zM0 11v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1H1a1 1 0 00-1 1zm10 0v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1h-6a1 1 0 00-1 1z",
        transform: "translate(3 3)"
    })));
};
GalleryGrid.displayName = 'GalleryGrid';
export default GalleryGrid;
